import React from 'react'
import PropTypes from 'prop-types'
import { Icon, CaretDownIcon } from 'src/components/icons'
import { mergeProps } from 'src/util'
import styles from './Select.scss'

/**
 * Native select with custom style.
 */
const Select = ({ color, ...domProps }) => (
  <div className={styles.container}>
    <select {...mergeProps()({ className: [styles.select, styles[color]] }, domProps)} />
    <Icon fixedWidth icon={CaretDownIcon} color={color} className={styles.caret} />
  </div>
)

Select.defaultProps = {
  color: 'light',
}

Select.propTypes = {
  /**
   * The focus color.
   */
  color: PropTypes.string,
}

export default Select
